import defaultlocale from '../../../common/locales/getDefaultLocale';
export const defaultLocale = defaultlocale;
export const DIRECTION_LTR = 'ltr';
export const DIRECTION_RTL = 'rtl';
export const REDIRECTION_SOURCES = {
  DEFAULT_SOURCE: 'oyo os',
  ANDROID: 'android'
};

const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || '';
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const FACEBOOK_CLIENT_ID = process.env.REACT_APP_FACEBOOK_CLIENT_ID || '';
const TRUECALLER_CLIENT_ID = process.env.REACT_APP_TRUECALLER_CLIENT_ID || '';

export const GOOGLE_SIGN_IN = {
  AUTH_LINK: 'https://accounts.google.com/o/oauth2/v2/auth',
  MODE: 'GMAIL',
  QUERY_PARAMS: {
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: REDIRECT_URI + '/propertyOnboard/social_login/gmail',
    response_type: 'code',
    state: 'googleState',
    prompt: 'select_account',
    scope: 'email profile'
  },
  LABEL: 'google'
};

export const PROPERTY_TAB_IDENTIFIER = {
  REACTIVATE: 'Reactivate',
  RECONTRACT: 'Recontract',
  IN_PROGRESS: 'In Progress'
};

export const EWB_AND_REACTIVATE_FIELDS = {
  AMENITIES: "amenities",
  IMAGES: "images",
  NO_OF_ROOMS: "number_of_floors",
  NO_OF_FLOORS: "number_of_rooms",
  GUEST_LANDLINE_PHONE_NUMBER: "guest_landline_phone_number",
  HOTEL_NAME: "hotel",
  ADDRESS: "address"
};

export const FACEBOOK_SIGN_IN = {
  AUTH_LINK: 'https://www.facebook.com/v10.0/dialog/oauth',
  MODE: 'FACEBOOK',
  QUERY_PARAMS: {
    client_id: FACEBOOK_CLIENT_ID,
    redirect_uri: REDIRECT_URI + '/propertyOnboard/social_login/facebook',
    response_type: 'code',
    state: 'facebookState',
    auth_type: 'rerequest',
    scope: 'email'
  },
  LABEL: 'facebook'
};

export const TRUECALLER_SIGN_IN = {
  AUTH_LINK: 'truecallersdk://truesdk/web_verify',
  MODE: 'TRUECALLER',
  DEEP_LINK_WINDOW_EXPIRY: 1000,
  POLLING_COUNT: 3,
  POLLING_INTERVAL: 1000,
  POLLING_CONTINUE_ERROR_MSG: 'No callback received',
  USED_ANOTHER_NUMBER: 'used_another_number',
  SDK_CLOSE_TIME_CHECK: 500,
  QUERY_PARAMS: {
    type: 'btmsheet',
    partnerKey: TRUECALLER_CLIENT_ID,
    partnerName: 'OYO',
    lang: 'en',
    skipOption: 'useanothermethod',
    ctaPrefix: 'continuewith'
  }
};

export const CoOyo_Download_Link = {
  url: 'https://cooyo.page.link/home'
};
export const patron_page = {
  url: 'https://patron.oyorooms.com'
};
export const TASK_NAME_MAP = {
  ROOM_AMENITIES: 'facilities',
  ADD_ROOM_CATEGORIES: 'add_rooms',
  ADD_IMAGES: 'images',
  KYC: 'kyc',
  BASIC_INFO: 'basic_info',
  ADDRESS: 'address',
  CONTACT_INFO: 'contact_info',
  REVIEW: 'review',
  TOS: 'term_of_service',
  SUCCESS: 'success'
};

export const SELF_ONBOARDING_CHECKLIST_STATUS = {
  EDITABLE: 'editable'
};

export const SELF_ONBOARDING_PHASE = {
  L1: 'L1',
  L2: 'L2'
};

export const SELF_ONBOARDING_PROPERTY_TYPE = {
  EWB_OYO: 'EWB OYO'
};

export const DOMAIN_AND_SUB_DOMAIN = {
  KYC_DOMAIN: 'PROPERTY_ONBOARDING',
  KYC_SUB_DOMAIN: 'KYC_FORM_CONFIG',
  SELF_ONBOARDING_PHOTO_ASSISTANCE: 'PHOTO_ASSISTANCE_CONFIG',
  SELF_ONBOARDING_PHOTO_TIPS: 'PHOTO_TIPS_CONFIG',
  SELF_ONBOARDING_SAMPLE_IMAGES: 'SELF_ONBOARDING_SAMPLE_IMAGES',
  IMAGES_DOMAIN: 'CCP!PROPERTY_ONBOARDING!0',
  KYC_SUB_DOMAIN_V2: 'KYC_FORM_CONFIG_V2'
};
export const ScreenURLMap = {
  property_onboard_task_details: {
    url: '/propertyOnboard/task/details',
    countrySpecificUrl: '/propertyOnboard/:country_iso_code/task/details',
    screenName: 'propertyOnboardTaskDetailsScreen'
  },
  property_onboard_task: {
    url: '/propertyOnboard/task',
    countrySpecificUrl: '/propertyOnboard/:country_iso_code/task',
    screenName: 'propertyOnboardTaskScreen'
  },
  property_dashboard: {
    url: '/propertyOnboard/dashboard',
    countrySpecificUrl: '/propertyOnboard/:country_iso_code/dashboard',
    screenName: 'propertyDashboardScreen'
  },
  property_account: {
    url: '/propertyOnboard/account',
    countrySpecificUrl: '/propertyOnboard/:country_iso_code/account',
    screenName: 'propertyAccountScreen'
  },
  property_info: {
    url: '/propertyOnboard/add',
    countrySpecificUrl: '/propertyOnboard/:country_iso_code/add',
    screenName: 'propertyAddScreen'
  },
  property_middleware: {
    url: '/propertyOnboard',
    countrySpecificUrl: '/propertyOnboard/:country_iso_code',
    screenName: 'propertyScreen'
  },
  mobile_otp_login: {
    url: '/propertyOnboard/sign_up',
    countrySpecificUrl: '/propertyOnboard/:country_iso_code/sign_up',
    screenName: 'mobileOTPLogin'
  }
};

export const ImagesPreferencesType = {
  ASSIST: 'assist',
  TIPS: 'tips',
  IMAGES: 'images',
  MERCHANT_KYC: 'merchant_kyc',
  OCR_ENUMS: {
    aadhaar: 'AADHAAR',
    voterId: 'VOTER_ID',
    drivingLicense: 'DRIVING_LICENSE',
    passport: 'PASSPORT',
    pan: 'PAN',
    vehicleRc: 'VEHICLE_RC'
  },
  OCR_ERROR_MISMATCH: 'Uploaded Image is of different IdType'
};

export const UnifiedContractLink = 'https://partners.oyorooms.com/terms-of-service';

export const API_INTENT = {
  LOGIN: 'selfOnboarding_login',
  ADD_PROPERTY: 'selfOnboarding_addproperty',
  VIEW_LEADS: 'selfOnboarding_viewLeads',
  COMPLETE_CHECKLIST: 'selfOnboarding_completeChecklist',
  DISSOCIATE_PROPERTY: 'selfOnboarding_dissociateProperty',
  SELF_ONBOARDING_IMAGE_UPLOAD: 'selfOnboarding_image_upload',
  PROPERTY_TYPE: 'selfOnboarding_propertyType',
  CONFIRM_ADDRESS: 'selfOnboarding_confirmAddress',
  LOCATION_DETAILS: 'selfOnboarding_locationDetails',
  PROPERTY_REVIEW: 'selfOnboarding_propertyReview',
  PUBLISH_PROPERTY: 'selfOnboarding_publishProperty',
  REFERRAL: 'selfOnboarding_referral'
};

export const OTA_CHANNEL = {
  OYOROOMS: 'oyorooms.com'
};

export const LOGIN_PERSONNEL = {
  PM: 'PM',
  OWNER: 'OWNER',
  EMPLOYEE: 'Employee'
};

export const WIDGET_TYPE = ['COLD_LEAD_TYPE_NOT_SERVICEABLE', 'COLD_LEAD_TYPE_UNSUPPORTED_PROPERTY'];

export const ROLE_IN_HOTEL = {
  [LOGIN_PERSONNEL.PM]: {
    role: 'PropertyManager'
  },
  [LOGIN_PERSONNEL.OWNER]: {
    role: 'Owner_Portal_User'
  }
};

export const SUB_SOURCE = {
  MERCHANT_ON_BOARDING_OVH: 'MERCHANT_ON_BOARDING_OVH',
  MERCHANT_ON_BOARDING_OYO: 'MERCHANT_ON_BOARDING',
  OVH: 'Merchant On-boarding Ovh',
  OYO: 'Merchant On-boarding'
};

export const FEATURE = {
  OVH360L1: 'OVH360L1'
};

export const PAGE_TYPE = {
  PHOTO_COMPLETION_PAGE: 'photo_completion_page',
  OYO360_COMPLETION_PAGE: 'oyo360_completion_page',
  AMENITIES_L1_PAGE: 'amenities_l1_page',
  SELF_ONBOARDING_L1: 'self_onboarding_l1',
  PROPERTY_TYPE: 'property_type',
  LOCATION_DETAILS_PAGE: 'location_details_page',
  MANUAL_ADDRESS: 'manual_address_page',
  AUTO_ADDRESS: 'auto_address_page',
  PROPERTY_INFO_L1_PAGE: 'property_info_l1_page',
  OYO360_LOGIN_PAGE: 'oyo360_login_page',
  KYC_L1_PAGE: 'kyc_l1_page',
  DASHBOARD: 'dashboard_page',
  REVIEW: 'property_preview_page',
  TERMS_OF_SERVICE_PAGE: 'terms_of_service_page',
  REFERRAL_UPDATE: 'referral_update'
};

export const PROPERTY_TYPE = {
  HOTELS: 'HOTELS',
  HOMES: 'HOMES',
  OVH: 'Merchant On-boarding Ovh HOME',
  HOME: 'HOME',
  HOTEL: 'HOTEL',
  OVH_HOME: 'OVH_HOME'
};

export const SOURCE_TYPE = {
  EWB: 'EWB',
  OTA: 'OTA'
};

export const CATEGORY_TYPE = {
  SELF_ONBOARDING_HOMES: 'self_onboarding_homes',
  SELF_ONBOARDING_HOTELS: 'self_onboarding_hotels'
};

export const CATEGORY_OTHERS = 'Others';
export const INFO_BANNER = 'INFO_BANNER';
export const MERCHANT_OVH = 'Merchant On-boarding Ovh';
export const OVH_PAGE_TYPE = 'oyo360_checklist_l1_page';
export const CHECKLIST_PAGE = 'checklist_page';
export const SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/png'];
export const KYC_SUPPORTED_IMAGE_FORMATS = ['image/jpeg', 'image/png'];
export const DECLARATION_STATEMENT = 'declaration_statement';
export const IN_PROGRESS = 'IN_PROGRESS';
export const COMPLETED = 'COMPLETED';
export const MERCHANT_PLATFORM = 'Merchant Platform';
export const CHECKLIST = 'CHECKLIST';
export const EXIT = 'EXIT';
export const PROPERTY_ONBOARD = 'propertyOnboard';
export const SELF_ONBOARDING = 'self_onboarding';

export const OYO_COORPORATE_LOC = {
  LATITUDE: 28.3991744,
  LONGITUDE: 77.03876529999999
};

export const VERSION = {
  V2: 'v2'
};

export const CTA_TYPES = {
  ADD: 'add',
  EDIT: 'edit'
};

export const maxImageSize = 10 * 1024 * 1024; // 10 MB

export const minImageWidth = 1000;

export const minImageHeight = 1000;

export const kycMaxImageSize = 10 * 1024 * 1024; // 10 MB

export const OYOOS_HOME_PAGE_LINK = '/hotel/:hotel_id/home';

export const resendOTPSeconds = 30;

export const REVIEW_AMENITY_COUNT = 6;

export const CATEGORY = {
  PROPERTY_WIDGET_CATEGORY: 'property_type',
  LOCATION_DETAILS: 'location_details',
  LOCATION_DETAILS_HOME: 'location_details_home'
};

export const socialLogins = {
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
  TRUECALLER: 'truecaller',
  APPLE: 'apple'
};

export const COMMISSION_DEAL_TYPES = {
  FLEXI: 'FLEXI',
  CRYSTAL: 'CRYSTAL'
};
export const COMMISSION_FIELD_TYPES = {
  FEE: 'fee',
  DATE_RANGE: 'date_range',
  WALKIN_CHANNEL: 'walkin_channel',
  OYO_CHANNEL: 'oyo_channel',
  COMMISSION: 'commission',
  SERVICE_FEE: 'service_fee',
  CHANNEL_FEE: 'channel_fee',
  TOTAL_FEE: 'total_fee',
  WALK_IN_WAIVER: 'walk_in_waiver',
  OTA_FEE: 'ota_fee'
};

export const DEAL_DISCOUNTING_COLUMN_WIDTH = 80;
export const DEAL_DISCOUNTING_OPTIONS = { day: 'numeric', month: 'short', year: 'numeric' };
export const REFERRAL_POPUP = {
  CONFIRMATION: 'confirmation',
  THANKS: 'thanks',
  INPUT: 'input',
  POPUP: 'popup',
};

export const REFERRAL_CTA_TYPES = {
  NAVIGATION: 'navigation',
  API: 'api'
};

export const REFERRAL_API_TAGS = {
  UPDATE: 'update',
  DELETE: 'delete',
  VERIFY: 'verify'
};

export const WIDGET_TYPES = {
  REFERRAL_HEADER: 'REFERRAL_HEADER',
  REFERRAL_CONFIRMATION: 'REFERRAL_CONFIRMATION',
  REFERRAL_THANKS: 'REFERRAL_THANKS',
  REFERRAL_INPUT: 'REFERRAL_INPUT',
  REFERRAL_POPUP: 'REFERRAL_POPUP'
};

export const TOS_ICON_TYPES = {
  COMMISSION_CHARGES: 'commissionCharges'
};


export const REFERRAL_POP_UP_DEFAULT_STRINGS = {
  MORE: 'More',
  ADD_REFERRAL: 'Add Referral',
  COPY_LEAD_ID: 'Copy Lead ID'
};